module.exports = __webpack_public_path__ + "static/maps-0a0b204f12ea036870e2766edaca39fa.svg";